import React from 'react'
import type { ContractVehicleType } from './types'
import { useDropdown } from './useDropdown'

interface ContractVehicleDropdownProps {
  contractVehicles?: ContractVehicleType[]
  selectedContractVehicle?: ContractVehicleType | null
  handleAddContractVehicleClick: (cv: ContractVehicleType) => void
  handleUnselectContractVehicle: () => void
}

const ContractVehicleDropdown: React.FC<ContractVehicleDropdownProps> = ({
  contractVehicles = [],
  selectedContractVehicle = null,
  handleAddContractVehicleClick,
  handleUnselectContractVehicle
}) => {
  const {
    isOpen,
    containerRef,
    buttonRef,
    setItemRef,
    handleToggle,
    handleButtonKeyDown,
    handleItemKeyDown,
    close
  } = useDropdown()

  const placeholderText = 'Select a Contract Vehicle'

  const handleItemClick = (cv: ContractVehicleType): void => {
    handleAddContractVehicleClick(cv)
    close()
  }

  const handleUnselectClick = (): void => {
    handleUnselectContractVehicle()
    close()
  }

  const naspoFirst = (a: ContractVehicleType, b: ContractVehicleType): number => {
    if (a.name === 'NASPO ValuePoint') return -1
    if (b.name === 'NASPO ValuePoint') return 1
    return 0
  }

  const sortedVehicles = [...contractVehicles].sort(naspoFirst)

  const text = selectedContractVehicle != null ? selectedContractVehicle.name : placeholderText
  const disabled = contractVehicles.length < 1

  return (
    <div id='contract-vehicle-dropdown' className='select-dropdown-container' ref={containerRef}>
      <label className='dropdown-label'>Contract Vehicle</label>
      <button
        ref={buttonRef}
        type='button'
        onClick={handleToggle}
        disabled={disabled}
        className='dropdown-button'
        onKeyDown={handleButtonKeyDown}
        aria-haspopup='listbox'
        aria-expanded={isOpen}
      >
        {text}
        <i className='fa-solid fa-sort dropdown-icon' />
      </button>
      {isOpen && (
        <div className='select-dropdowns'>
          <ul role='listbox' aria-label='Contract Vehicle'>
            <li
              ref={setItemRef(0)}
              role='option'
              aria-selected={selectedContractVehicle == null}
              tabIndex={-1}
              onClick={handleUnselectClick}
              onKeyDown={(e) => handleItemKeyDown(e, 0)}
            >
              {placeholderText}
            </li>
            {sortedVehicles.map((cv, i) =>
              <li
                key={cv.id}
                ref={setItemRef(i + 1)}
                role='option'
                aria-selected={selectedContractVehicle?.id === cv.id}
                tabIndex={-1}
                onClick={() => handleItemClick(cv)}
                onKeyDown={(e) => handleItemKeyDown(e, i + 1)}
              >
                {cv.name}
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}

export { ContractVehicleDropdown }
